// @flow

import type { State } from './types';

type GlobalState = {
  newsSettings: State,
};

export const getNewsSettings = (state: GlobalState): State => {
  const { newsSettings } = state;
  if (!newsSettings) {
    throw new Error('Missing newsSettings store.');
  }
  return newsSettings;
};

type NewsOverviewLink = $PropertyType<State, 'news_overview_link'>;
export const getNewsOverviewLink = (state: GlobalState): NewsOverviewLink => (
  getNewsSettings(state).news_overview_link
);

type NewsOverviewLinkLabel = $PropertyType<State, 'news_overview_link_label'>;
export const getNewsOverviewLinkLabel = (state: GlobalState): NewsOverviewLinkLabel => (
  getNewsSettings(state).news_overview_link_label
);

type NewsReadMoreLabel = $PropertyType<State, 'read_more_label'>;
export const getNewsReadMoreLabel = (state: GlobalState): NewsReadMoreLabel => (
  getNewsSettings(state).read_more_label
);

type NewsLatestArticlesLabel = $PropertyType<State, 'latest_articles_label'>;
export const getLatestArticlesLabel = (state: GlobalState): NewsLatestArticlesLabel => (
  getNewsSettings(state).latest_articles_label
);

type NewsShareLabel = $PropertyType<State, 'share_label'>;
export const getNewsShareLabel = (state: GlobalState): NewsShareLabel => (
  getNewsSettings(state).share_label
);

type NewsLoadMoreLabel = $PropertyType<State, 'load_more_label'>;
export const getNewsLoadMoreLabel = (state: GlobalState): NewsLoadMoreLabel => (
  getNewsSettings(state).load_more_label
);
